var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"fluid":""}},[_c('report-title',{staticClass:"mb-2",attrs:{"title":_vm.options.title}}),_c('report-filter',{on:{"change-filter":function($event){return _vm.fetchReport($event)}}}),_c('report-table',{attrs:{"headers":_vm.options.headers,"items":_vm.options.data}}),_c('report-alert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }